import {lazy} from 'react';

const NoRole = lazy(() => import('./NoRole'));

export default NoRole;
